/**
 * ISO day of the week with 1 being Monday and 7 being Sunday https://day.js.org/docs/en/get-set/iso-weekday
 */
export const DayOfWeekIso = Object.freeze({
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
  SUNDAY: 7,
})
